import React from 'react';
import { Box, Typography, Paper, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function Privacy() {
  return (
    <Box sx={{ maxWidth: 700, mx: 'auto', mt: 6, mb: 6, px: 2 }}>
      <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, backgroundColor: '#fff' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <img
            src="/images/race-with-me-logo-blue.png"
            alt="RaceWithMe - F1 Game Racing Community Logo"
            style={{ height: '80px', maxWidth: '100%', objectFit: 'contain' }}
          />
        </Box>
        <Typography variant="h4" sx={{ fontFamily: '"Orbitron", "Roboto", "Helvetica", "Arial", sans-serif', fontWeight: 700, mb: 3, color: 'primary.main' }}>
          Privacy Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Introduction
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Race With Me is committed to protecting your privacy. This policy describes what information we collect, how we use it, and your rights regarding that information when you use our website and services.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Information we collect
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          We collect information you provide when you register and use the service:
        </Typography>
        <ul style={{ marginBottom: 16 }}>
          <li><Typography variant="body1">Email address (used for account creation and sign-in)</Typography></li>
          <li><Typography variant="body1">EA ID (your gaming identifier, shared with other users when you create a race card or when your application to a card is accepted)</Typography></li>
          <li><Typography variant="body1">Profile information you add to your account or race cards (e.g. platform, game mode preferences)</Typography></li>
          <li><Typography variant="body1">Content you create (race cards, applications to cards, messages related to applications)</Typography></li>
        </ul>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We also store in-app notifications (e.g. when someone applies to your card or when your application is accepted or rejected) so you can view them when logged in.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          How we use your information
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We use your information to run the service: to create and manage your account, display and match race cards, show your EA ID to relevant users when appropriate, send you in-app notifications about applications and card updates, and improve the service. We do not sell your personal information to third parties.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Third-party services
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We use Google Firebase (authentication and cloud database) to run the service. Your email, account data, race cards, and notifications are stored and processed by Firebase. Google&apos;s privacy practices apply to that processing. By using Race With Me, you agree to the use of these services as described in their respective privacy policies.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Who can see your information
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Your EA ID and card details are visible to other logged-in users when you create a race card or when your application to someone else&apos;s card is accepted. Notifications are visible only to you when you are logged in. We do not share your email address with other users.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Data retention
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We retain your account and card data while your account is active. We may retain limited data for a reasonable period after account deletion for legal or operational reasons. Old notifications may be automatically removed to keep the service running smoothly.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Your rights
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You can access and update your profile and EA ID from your account page. You can delete individual race cards and manage your applications from the site. If you wish to delete your account or request a copy of your data, please contact us using the details below.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Security
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We use industry-standard authentication and secure connections. Account access is protected by your password; please keep your login details secure.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Changes to this policy
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We may update this privacy policy from time to time. The &quot;Last updated&quot; date at the top will be revised when we do. Continued use of the service after changes constitutes acceptance of the updated policy.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Contact us
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          For privacy-related questions, to request account deletion, or to request a copy of your data, contact us at:{' '}
          <Link href="mailto:racewithmehelp@gmail.com" sx={{ fontWeight: 600, color: 'primary.main' }}>
            racewithmehelp@gmail.com
          </Link>
        </Typography>

        <Typography variant="body1">
          <Link component={RouterLink} to="/help" sx={{ color: 'primary.main' }}>
            ← Back to Help & About
          </Link>
        </Typography>
      </Paper>
    </Box>
  );
}

export default Privacy;
